import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import React from 'react'
import useSWR from 'swr'
import { create } from 'zustand'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

const PAGE_SIZE = 100

export const useForm = create((set) => ({
  after: null,
  afters: [],
  goAfter: (nextAfter) =>
    set((state) => {
      if (nextAfter === null) {
        return { after: null }
      }
      const index = state.afters.findIndex((a) => a === nextAfter)
      if (index === -1) {
        return { after: nextAfter, afters: [...state.afters, nextAfter] }
      }
      return { after: nextAfter }
    }),
}))

const DlcPanel = () => {
  const after = useForm((s) => s.after)
  const params = {
    limit: PAGE_SIZE,
    ...(after ? { after } : {}),
  }
  const { data, isLoading, isValidating, mutate } = useSWR(['/dlcs', params])
  const nextAfter =
    data?.length >= PAGE_SIZE ? data[data.length - 1]?.id : undefined

  const table = useReactTable({
    data: data,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  if (isLoading || isValidating) return <Loader>Load dlcs...</Loader>
  if (!data) return <EmptyDatas />

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <div className="flex-shrink-0 mb-2">
        <DataTableToolbar mutate={mutate} nextAfter={nextAfter} />
      </div>
      <div className="flex-1 min-h-0">
        <Card className="h-full flex flex-col">
          <CardContent className="flex-1 overflow-hidden pl-4 pr-0 pb-0">
            <div className="h-full overflow-auto">
              <Table table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default DlcPanel
